class MFRMediaCallout {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            entry: ".media-callout__entry",
            texts: ".media-callout__texts",
            text: ".media-callout__text"
        }

        this.init()
    }

    init() {
        this.$entry = this.$element.find( this.selectors.entry );
        this.$texts = this.$element.find( this.selectors.texts );
        this.$text = this.$element.find( this.selectors.text );

        this.$element.find( this.selectors.text + `[data-index="1"]` ).show();

        this.$entry.on( "click", this.__handleEntryClick.bind( this ) );
    }

    __handleEntryClick( e ) {
        if( $( window ).width() > 1023 ) return;

        const index = $( e.currentTarget ).data( "index" );

        this.selectEntry( index );
    }

    selectEntry( index ) {
        const selectedText = this.$element.find( this.selectors.text + `[data-index="${index}"]` );
        const selectedEntry = this.$element.find( this.selectors.entry + `[data-index="${index}"]`);

        this.$entry.removeClass( "is-active" );
        selectedEntry.addClass( "is-active" );
        
        this.$text.removeClass( "is-active" );
        selectedText.addClass( "is-active" );

        setTimeout( () => this.$texts.height( selectedText.height() ), 400 );
    }
}